var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRotateRight = function SvgRotateRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9781 6.35C16.5281 4.9 14.5381 4 12.3281 4C7.90813 4 4.33813 7.58 4.33813 12C4.33813 16.42 7.90813 20 12.3281 20C16.0581 20 19.1681 17.45 20.0581 14H17.9781C17.1581 16.33 14.9381 18 12.3281 18C9.01813 18 6.32813 15.31 6.32813 12C6.32813 8.69 9.01813 6 12.3281 6C13.9881 6 15.4681 6.69 16.5481 7.78L13.3281 11H20.3281V4L17.9781 6.35Z",
    fill: "#8B9294"
  })));
};
export default SvgRotateRight;